var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeqUnit = function SvgSeqUnit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "seq-unit_svg__path-1",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "seq-unit_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "seq-unit_svg__export",
    transform: "translate(-174 -251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "seq-unit_svg__badges/seq-unit",
    transform: "translate(174 251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "seq-unit_svg__Group-2",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "seq-unit_svg__color/alexs-deep-blue/base-003595"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "seq-unit_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#seq-unit_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#seq-unit_svg__path-1",
    id: "seq-unit_svg__Mask",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("g", {
    id: "seq-unit_svg__color/alexs-deep-blue/base-003595(og)",
    fill: "#003996",
    mask: "url(#seq-unit_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "seq-unit_svg__alexs-deep-blue-003595",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "seq-unit_svg__Group",
    fill: "#FFF",
    fillRule: "nonzero",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "seq-unit_svg__Shape",
    d: "M0 6.5a6.5 6.5 0 0 1 13 0A6.51 6.51 0 0 1 6.5 13 6.5 6.5 0 0 1 0 6.5M8 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "seq-unit_svg__Shape",
    d: "M8 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-5a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "seq-unit_svg__Path-3",
    stroke: "#FFF",
    d: "M8.5 8.5c1 1.333 1.926 2.139 2.926 3.472z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "seq-unit_svg__noun_bar-chart_2342168",
    fill: "#FFF",
    fillRule: "evenodd",
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "seq-unit_svg__Shape",
    fillRule: "nonzero",
    d: "M.461 3.889H0V5h6V3.889h-.462L5.5 1.11H5V3.89H4V0h-.5v3.889h-1V1.11H2V3.89H1V0H.461z"
  })))))));
};
export default SvgSeqUnit;